<template>
  <div class="shop-order-traveler-section">
    <section
      v-for="(customer, index) in travelerCustomers"
      :key="'traveler-' + index"
      class="order-card"
    >
      <div class="section-title">{{ getCustomerTitleFn(customer, index, 'traveler') }}</div>
      <div class="form-grid">
        <template v-for="field in getVisibleCustomFieldsFn(customer.cus_type)">
          <div
            v-if="getFieldModeFn(field.config, field.key) !== 'country_cities'"
            :key="'cus-' + index + '-' + field.key"
            class="form-item"
            :class="{ 'form-item--full': isWideFieldFn(field.key) }"
          >
            <label>{{ getFieldLabelFn(field.key, field.config) }}<span v-if="isRequiredFn(field.config)" class="required">*</span></label>

            <el-input
              v-if="getFieldModeFn(field.config, field.key) === 'text'"
              v-model.trim="customer[field.key]"
              :placeholder="'请输入' + getFieldLabelFn(field.key, field.config)"
            ></el-input>

            <el-input
              v-else-if="getFieldModeFn(field.config, field.key) === 'number'"
              v-model.trim="customer[field.key]"
              type="number"
              :placeholder="'请输入' + getFieldLabelFn(field.key, field.config)"
            ></el-input>

            <el-input
              v-else-if="getFieldModeFn(field.config, field.key) === 'textarea'"
              v-model.trim="customer[field.key]"
              type="textarea"
              :rows="3"
              :placeholder="'请输入' + getFieldLabelFn(field.key, field.config)"
            ></el-input>

            <el-date-picker
              v-else-if="getFieldModeFn(field.config, field.key) === 'date'"
              v-model="customer[field.key]"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="请选择日期"
              style="width: 100%;"
            ></el-date-picker>

            <el-time-picker
              v-else-if="getFieldModeFn(field.config, field.key) === 'time'"
              v-model="customer[field.key]"
              value-format="HH:mm:ss"
              placeholder="请选择时间"
              style="width: 100%;"
            ></el-time-picker>

            <el-switch
              v-else-if="getFieldModeFn(field.config, field.key) === 'boolean'"
              v-model="customer[field.key]"
              :active-value="true"
              :inactive-value="false"
            ></el-switch>

            <el-select
              v-else
              v-model="customer[field.key]"
              filterable
              placeholder="请选择"
            >
              <el-option
                v-for="item in getFieldOptionsFn(field.config, field.key)"
                :key="'cus-opt-' + index + '-' + field.key + '-' + getOptionValueFn(item)"
                :label="getOptionLabelFn(item)"
                :value="getOptionValueFn(item)"
              />
            </el-select>
          </div>

          <div
            v-else
            :key="'cus-country-' + index + '-' + field.key"
            class="form-item form-item--full"
          >
            <label>{{ getFieldLabelFn(field.key, field.config) }}<span v-if="isRequiredFn(field.config)" class="required">*</span></label>
            <div class="inline-field">
              <el-select
                :value="getCountryParentFn(customer, getCustomerIndexFn(customer))"
                filterable
                placeholder="选择国家/地区"
                @input="setCountryParentFn(customer, getCustomerIndexFn(customer), $event)"
              >
                <el-option
                  v-for="item in getFieldOptionsFn(field.config, field.key)"
                  :key="'country-parent-' + index + '-' + item.id"
                  :label="getOptionLabelFn(item)"
                  :value="String(item.id)"
                />
              </el-select>
              <el-select
                v-model="customer[field.key]"
                filterable
                placeholder="选择城市"
              >
                <el-option
                  v-for="city in getCountryCitiesFn(customer, getCustomerIndexFn(customer), field.config)"
                  :key="'country-city-' + index + '-' + city.city_code"
                  :label="city.name"
                  :value="city.city_code"
                />
              </el-select>
            </div>
          </div>
        </template>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'ShopOrderTravelerSection',
  props: {
    travelerCustomers: { type: Array, required: true },
    getCustomerTitleFn: { type: Function, required: true },
    getVisibleCustomFieldsFn: { type: Function, required: true },
    getFieldModeFn: { type: Function, required: true },
    isWideFieldFn: { type: Function, required: true },
    getFieldLabelFn: { type: Function, required: true },
    isRequiredFn: { type: Function, required: true },
    getFieldOptionsFn: { type: Function, required: true },
    getOptionValueFn: { type: Function, required: true },
    getOptionLabelFn: { type: Function, required: true },
    getCountryParentFn: { type: Function, required: true },
    getCustomerIndexFn: { type: Function, required: true },
    setCountryParentFn: { type: Function, required: true },
    getCountryCitiesFn: { type: Function, required: true },
  },
};
</script>

<style scoped>
@import './shopOrderSection.css';
</style>



// WEBPACK FOOTER //
// src/pages/shop/components/ShopOrderTravelerSection.vue